import React from "react";
import { navigate } from "gatsby";

const ProjectLicenses = () => {
  return (
    <div>
      <p className="detail-text paragraph">
        With project licenses you can choose to license tracks individually or
        license entire sessions (albums) at a discounted rate. While browsing
        for music, look for the cart icon to purchase a project license for your
        music. If you are logged in you may need to click on “download” to add
        the track to your cart.
      </p>{" "}
      <p className="detail-text paragraph">
        <p className="paragraph-title">Which license level do I need?</p>
        The license levels are based on “overall project budget”. This includes
        all expenses incurred and salaries for the project in question. The
        lowest license level “Basic” is intended for very small projects that
        are not significantly monetized (a small YouTube channel with ads,
        Patreon supported, a promotional video for a small business). Most
        projects produced semi-professionally would require a Standard or
        Professional level license.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          {" "}
          What if I don't know the exact budget of my project?
        </p>
        We offer wide ranges of project budgets as part of our sliding scale
        licensing levels. We know it can be a hard thing to come up with exact
        figures for this. Fortunately it doesn't have to be an exact figure, and
        the license can always be upgraded later (if your film has been picked
        up by a distributor for example).
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title"> What does the license cover?</p>
        You can read the license text as a PDF if you go to checkout and look
        for the appropriate link.Typically our licenses are very simple and
        offer worldwide /in-perpetuity licensing for your work.Our project
        licenses are not “buy-out licenses” so the license is linked to your
        specific work. If you are producing another film, for example, you would
        need to purchase an additional license for that film.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          What if my project doesn't fit the categories or has special licensing
          needs?
        </p>
        That's OK! Our stock license levels aren't intended to cover every way
        that our music can be used. You can just reach out if you have questions
        and we can either direct you to the right license type or set up a
        custom licensing agreement.
        <p>
          {" "}
          <button
            onClick={() => navigate("/contact")}
            className="license-button"
            style={{ marginTop: 32, marginBottom: -12 }}
          >
            Contact us!
          </button>
        </p>
      </p>
    </div>
  );
};

export default ProjectLicenses;
